import { mapActions, mapGetters } from "vuex";
import { addStep, start } from "../../lib/intro";

export default {
  name: "Home",

  metaInfo: {
    title: "Panel de control"
  },

  components: {
    FreeAccountBanner: () =>
      import("../../components/Home/FreeAccountBanner.vue"),
    CallsList: () => import("../../components/Home/CallsList"),
    LastWeekStats: () => import("../../components/Home/LastWeekStats"),
    Overlay: () => import("../../components/Overlay"),
    ProjectConfig: () => import("../../components/Home/ProjectConfig"),
    ProjectInfo: () => import("../../components/Home/ProjectInfo"),
    SourceCode: () => import("../../components/SourceCode.vue")
  },

  data: () => ({
    loading: true,

    intros: []
  }),

  computed: {
    ...mapGetters({
      project: "getProject",
      user: "getUser"
    })
  },

  methods: {
    addIntro({ id, name, element, str, step }) {
      this.intros.push({
        id,
        name,
        element,
        introStr: str,
        step
      });

      this.intros.sort((a, b) => parseInt(a.step) - parseInt(b.step));

      if (this.intros.length === 4) {
        this.addIntro({
          id: 4,
          name: "source-code",
          element: this.$refs["source-code"].$el,
          str:
            "Inserta el botón del llamadas en tu sitio o comparte el enlace de llamada.",
          step: 4
        });

        for (let intro of this.intros) addStep(intro);
        setTimeout(() => start(), 2000);
      }
    },

    ...mapActions(["findProject"])
  },

  async created() {
    if (!this.project) {
      this.$router.push({
        name: "welcome"
      });
    } else {
      this.loading = false;
    }
  }
};
